import { getModuleIdsFromGrants } from '@realadvisor/constants';

import type { GetUserNotificationSettingsQuery } from '@graphql/__generated__/graphql';
import {
  type NotificationSetting,
  isAnyChannelOffered,
} from '@modules/notifications/notificationChannels';

type NotificationUser = NonNullable<
  GetUserNotificationSettingsQuery['users_by_pk']
>;

export type NotificationUserFacts = {
  countryCode: string;
  moduleIds: readonly string[];
  isTeamLeader: boolean;
};

export const getNotificationUserFacts = (
  user: Pick<NotificationUser, 'tenant' | 'module_grants' | 'teams_users'>,
): NotificationUserFacts => ({
  countryCode: user.tenant.country_code,
  moduleIds: getModuleIdsFromGrants(user.module_grants),
  isTeamLeader: user.teams_users.length > 0,
});

const isInAudience = (audience: string, isTeamLeader: boolean): boolean => {
  if (audience === 'team_leaders') {
    return isTeamLeader;
  }

  if (audience === 'members') {
    return !isTeamLeader;
  }

  return true;
};

export const isNotificationEligible = (
  setting: Pick<
    NotificationSetting,
    | 'is_active'
    | 'country_codes'
    | 'modules'
    | 'audience'
    | 'email_available'
    | 'sms_available'
    | 'push_available'
    | 'team_leader_cc_available'
  >,
  user: NotificationUserFacts,
): boolean =>
  setting.is_active &&
  (setting.country_codes == null ||
    setting.country_codes.includes(user.countryCode)) &&
  (setting.modules == null ||
    setting.modules.some(module => user.moduleIds.includes(module))) &&
  isInAudience(setting.audience, user.isTeamLeader) &&
  isAnyChannelOffered(setting);
